export class SavedsearchesModel {
  public savedSearchList: string;
  public savedTripsList: SavedTripsList[] = [];

  constructor(savedSearchedresponse: any) {
    if (
      savedSearchedresponse.status !== undefined &&
      savedSearchedresponse.status !== null
    ) {
      this.savedSearchList = savedSearchedresponse.status.toLowerCase();
    } else {
      this.savedSearchList = null;
    }
    savedSearchedresponse.customer.savedTripList.forEach((savedTrip, index) => {
      this.savedTripsList[index] = new SavedTripsList(savedTrip);
    });
  }
}

export class SavedTripsList {
  public alias: string;
  public areAirportsFlexible: boolean;
  public areAirportsFlexibleDestination: boolean;
  public areAirportsFlexibleOrigin: boolean;
  public cabin: string;
  public cabinClassDescription: string;
  public corporateAgreementInfo: string;
  public id: string;
  public isNonstop: boolean;
  public isRedeemMiles: boolean;
  public isRefundable: boolean;
  public isUpgradeable: boolean;
  public nearbyAirportsByDestinations: string[] = [];
  public nearbyAirportsByOrigins: string[] = [];
  public numberOfPassengers: number;
  public origDestInfos: TravelDetails[] = [];
  public prefOACarrier: string;
  public primaryTripIndicator: boolean;
  public travelType: string;
  public tripType: string;
  public cabinClassCode: string;

  constructor(savedTrips: any) {
    this.alias = savedTrips.alias;
    this.areAirportsFlexible = false;
    this.areAirportsFlexibleDestination =
      savedTrips.isAirportFlexibleDestination;
    this.areAirportsFlexibleOrigin = savedTrips.isAirportFlexibleOrgin;
    this.cabin = savedTrips.cabinClassCode;
    this.cabinClassDescription = savedTrips.cabinClassDescription;
    this.corporateAgreementInfo = null;
    this.id = savedTrips.id;
    this.isNonstop = savedTrips.isNonstop;
    this.isRedeemMiles = savedTrips.isRedeemMiles;
    this.isRefundable = savedTrips.isRefundable;
    this.isUpgradeable = false;
    this.numberOfPassengers = savedTrips.passengerCount;
    this.prefOACarrier = null;
    this.primaryTripIndicator = savedTrips.isPrimary;
    this.travelType = savedTrips.travelType;
    this.tripType = null;
    this.origDestInfos[0] = new TravelDetails();
    this.origDestInfos[0].departureTime = savedTrips.departureTime;
    this.origDestInfos[0].returnTime = savedTrips.arrivalTime;
    this.origDestInfos[0].destinationCityCd = savedTrips.destinationCityCode;
    this.origDestInfos[0].originCityCd = savedTrips.originCityCode;
    this.origDestInfos[0].id = savedTrips.id;
    this.cabinClassCode = savedTrips.cabinClassCode;
  }
}

export class TravelDetails {
  public departureTime: string;
  public destinationCityCd: string;
  public id: string;
  public originCityCd: string;
  public returnTime: string;

  constructor() {}
}
